(function () {
  "use strict";

  angular.module("sempraWebapp", [
    "ngAnimate",
    "ngCookies",
    "ngSanitize",
    "ngMessages",
    "ngAria",
    "ui.router",
    "ngMaterial",
    "toastr",
    "eventBus",
    "app.config",
    "angularUtils.directives.uiBreadcrumbs",
    "md.data.table",
    "pascalprecht.translate",
    "datePicker",
    "ui.bootstrap",
    "ngLocale",
    "angular-jwt",
    "appVersion",
    "ngFileUpload"
  ]);
})();
